export default __webpack_public_path__ + "static/media/claims.44535878.svg";